import React, { ReactElement, useCallback } from 'react';
import { Formik, FormikProps } from 'formik';
import * as yup from 'yup';
import { withLoader } from 'b2b-apps/shop/common/hoc/withLoader';
import { useTranslate } from 'b2b-apps/shop/i18n/hooks';
import { Body } from './Body';
import { FIELD_NAME, FormValuesType, Props } from './';

const Form = ({
  onSubmit,
  onModalClose,
  currentWishlist,
  onChange,
  options,
  onLoadOptions,
  itemCount,
}: Props): ReactElement => {
  const t = useTranslate();

  const validationSchema = yup.object().shape({
    [FIELD_NAME.selectedWishlist]: yup.mixed().required(t('Required')),
  });

  const renderBody = useCallback(
    (formikProps: FormikProps<FormValuesType>): ReactElement => (
      <Body {...formikProps}
            onModalClose={onModalClose}
            currentWishlist={currentWishlist}
            onChange={onChange}
            options={options}
            onLoadOptions={onLoadOptions}
            itemCount={itemCount}
      />
    ),
    [onModalClose, currentWishlist, onChange, options, onLoadOptions],
  );

  return (
    <Formik
      initialValues={{
        [FIELD_NAME.selectedWishlist]: currentWishlist || '',
      }}
      onSubmit={onSubmit}
      validationSchema={validationSchema}
    >
      {renderBody}
    </Formik>
  );
};

const ComposedForm = withLoader(({ wishlists }: Props) => [wishlists], false)(Form);

export { ComposedForm as Form };
